import { Input } from 'antd'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './pure-input-range.module.scss'

type InputProps = {
  style?: any
  // TODO fix
  value: any
  label?: string
  placeholder?: string
  colClass?: string
  moduleStyle?: string
  icon?: React.ReactNode
  name?: string
  error?: string | string[]
  required?: boolean
  size?: SizeType
  type?: string
  className?: string
  disabled?: boolean
  from?: string
  to?: string
  onInput?: (value: any) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const PureInputRange: React.FC<InputProps> = ({
  value,
  label,
  colClass,
  moduleStyle,
  icon,
  error,
  required = true,
  size = 'middle',
  className = '',
  onInput,
  type = 'number',
  from = '',
  to = '',
  ...rest
}) => {
  const { t } = useTranslation()
  const [fromPlaceholder, setFromPlaceholder] = useState<string>('')
  const [toPlaceholder, setToPlaceholder] = useState<string>('')

  const [valueFrom, setValueFrom] = useState<number>(0)
  const [valueTo, setValueTo] = useState<number>(0)

  useEffect(() => {
    setFromPlaceholder(from || t('common.from'))
    setToPlaceholder(to || t('common.to'))
  }, [from, to])

  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.inputRangeStyles, className)}>
      {label ? (
        <div className="label d-block mt-2 mb-1 fs-6">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}
      <div className={clsx('col-12', 'd-flex', 'justify-content-between', 'align-items-center')}>
        <Input
          onChange={(e) => setValueFrom(Number(e.target.value))}
          placeholder={fromPlaceholder}
          size={size}
          type={type}
          value={value}
          {...rest}
        />
        <span>-</span>
        <Input
          onChange={(e) => setValueTo(Number(e.target.value))}
          placeholder={toPlaceholder}
          size={size}
          status={error ? 'error' : ''}
          suffix={icon}
          type={type}
          value={value}
          {...rest}
        />
      </div>
      {error ? <div className="error-message">{error}</div> : null}
    </div>
  )
}
